import { Button } from '@mui/material';
import React from 'react';
import GetAppIcon from '@mui/icons-material/GetApp';

interface ExportToExcelButtonProps {
	handleExportToExcel: () => void;
	disabled: boolean;
	variant?: 'contained' | 'outlined';
	label?: string;
	size?: 'small' | 'medium' | 'large';
}

export const ExportToExcelButton = ({
	disabled,
	handleExportToExcel,
	variant = 'contained',
	label,
	size = 'large',
}: ExportToExcelButtonProps): JSX.Element => {
	return (
		<Button
			disabled={disabled}
			variant={variant}
			size={size}
			startIcon={<GetAppIcon />}
			title={label ?? 'Exportar a excel'}
			onClick={handleExportToExcel}
			sx={label ? undefined : { marginRight: '10px' }}
		>
			{label}
		</Button>
	);
};
